<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheadingBold">
          <div class="ml-4 mt-4">
            {{item.title}}
          </div>
          <v-spacer/>
          <div class="mr-4 mt-4">
            {{displayDocumentIDGTypeA(item.tag, this.localForm.objectidg)}}
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.objectname"
            :prepend-icon="localForm.objecticon"
            :hint="this.localForm.objecthint"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.objectid"
            prepend-icon="fingerprint"
            hint="ID"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.authLevel"
            prepend-icon="key"
            hint="access level"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.auth"
            prepend-icon="person"
            persistent-hint
            hint="access request"
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <div v-if="this.approverVerify === true">
          <v-layout row :class="ui.textSubheadingBoldWarning">
            <div class="ml-4 mt-4">
              User Access Authority
            </div>
            <v-spacer/>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormAuth()"
                v-model="localForm.auth"
                :items="accessLevelCompany"
                color="wplblue0"
                prepend-icon="key"
                hint="access level"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
        <AccessDetailAuthDescribe/>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import describeAccess from "@/data/describe/mixins/describeAccess";
import selectAccess from "@/data/options/mixins/selectAccess.js";
import AccessDetailAuthDescribe from "@/support/access/components/AccessDetailAuthDescribe";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import { mapGetters } from "vuex";
// import TransitionsStage from "@/support/transitions/components/TransitionsStage";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        username: "",
        useremail: "",
        objectname: "", // company or facility
        objectid: "", // company or facility
        objecticon: "",
        objecthint: "",
        objecthints: "",
        auth: "",
        authLevel: ""
      },
      orgForm: {
        auth: ""
      },
      auth: ""
    };
  },
  components: {
    AccessDetailAuthDescribe
  },
  watch: {
    // whenever question changes, this function will run
    auth() {
      this.localForm.auth = this.auth;
      this.updateFormAuth();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.username = this.getDetail.char.utitle;
    this.localForm.useremail = this.getDetail.char.uemail;
    this.localForm.useridg = this.getDetail.char.uidg;
    // source doc.
    this.localForm.objectname = this.getDetail.char.title;
    this.localForm.objectid = this.getDetail.char.id;
    this.localForm.objectidg = this.getDetail.char.idg;
    // eslint-disable-next-line
    this.localForm.objecticon = this.defineDocumentFromTag(this.item.tag).icon;
    // eslint-disable-next-line
    this.localForm.objecthint = this.defineDocumentFromTag(this.item.tag).title;
    // eslint-disable-next-line
    this.localForm.objecthints = "ID";
    if (this.item.tag === "C1") {
      let auth = this.getDetail.select.cauth;
      this.localForm.auth = auth;
      this.orgForm.auth = auth;
      // this.localForm.objecthint = this.defineDocumentFromTag(this.item.tag).hint;
      if (auth === null) {
        this.localForm.authLevel = "Company Access";
        this.localForm.auth = 9;
      } else {
        this.localForm.authLevel = this.defineAccess(this.item.tag, auth).title;
      }
    } else {
      let auth = this.getDetail.select.fauth;
      this.localForm.auth = auth;
      this.orgForm.auth = auth;
      if (auth === null) {
        this.localForm.authLevel = "Facility Access";
        this.localForm.auth = 9;
      } else {
        this.localForm.authLevel = this.defineAccess(this.item.tag, auth).title;
      }
    }
  },
  mixins: [
    apptheme,
    numberFunctions,
    describeDocument,
    describeAccess,
    selectAccess,
    docRevsModFunctions,
    transFunctions,
    displayFunctions
  ],
  methods: {
    updateFormAuth() {
      // Ensure not active only when changed AGREE / DISAGREE btn is pressed
      // in VERIFY tab
      this.$store.dispatch("changeDataSavePendingIndication", false);
      let temp = this.getDetailSelect;
      // eslint-disable-next-line
      if (
        this.localForm.auth !== this.orgForm.auth &&
        this.localForm.auth !== ""
      ) {
        // basic
        if (this.getDetail.basic.tagd === "C1") {
          temp.cauth = parseInt(this.localForm.auth);
          // eslint-disable-next-line
        } else if (this.getDetail.basic.tagd === "F1") {
          temp.fauth = parseInt(this.localForm.auth);
        } else {
          // do nothing
          temp.fauth = null;
          temp.cauth = null;
        }

        // CHANGE TRANS BACK, NEW = FALSE for ACTIVE USERS
        // TO PREVNT DUPLICATE IN COUTER
        let trans = this.getTransitions;
        if (trans.stat.new === true && trans.stat.active === true) {
          trans.stat.new = false;
          console.log("NEW IS FALSE");
        }

        // Update Transitions Histriy
        let comment = "";
        // eslint-disable-next-line
        comment = "User Access changed from " + this.orgForm.auth + " to " + this.localForm.auth + " by Admin."
        this.updateTransitionHistory(comment, "Updated", "key");

        // after the change re-assign new Local to Org
        this.orgForm.auth = this.localForm.auth;

        this.$store.dispatch("changeDetailSelect", temp);
        this.saveDocumentRevMod(2.15, 1); // business mod.
      }
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getDetail",
      "getDetailSelect",
      "getTransitions"
    ]),
    approverVerify() {
      let verify = false;
      if (this.getDetailSelect.fauth === 0) {
        verify = false;
      } else if (this.getDetailSelect.cdid !== "") {
        let did = this.getDetailSelect.cdid;
        if (
          did === this.getUser.pref.select.cdid &&
          this.getUser.pref.select.cauth < 2
        ) {
          verify = true;
        } else {
          verify = false;
        }
      } else {
        // same check but for facility
        let did = this.getDetailSelect.fdid;
        if (
          did === this.getUser.pref.select.fdid &&
          this.getUser.pref.select.fauth < 2
        ) {
          verify = true;
        } else {
          verify = false;
        }
      }
      return verify;
    },
    type() {
      return "Comp";
    },
    item() {
      let obj = {
        title: "",
        tag: "",
        enableAccessLevel: false
      };
      let tagd = this.getDetail.basic.tagd;
      let tags = this.getDetail.basic.tags;
      if (tagd === "C1" && tags === "U1") {
        obj.title = "Company User Access";
        obj.tag = "C1";
        if (this.getDetail.select.cauth < 2) {
          obj.enableAccessLevel = true;
        }
      } else if (tagd === "Z5" && tags === "C1") {
        obj.title = "New Company Request";
        obj.tag = "C1";
        obj.enableAccessLevel = false;
      } else if (tagd === "U1" && tags === "C1") {
        obj.title = "User Company Access";
        obj.tag = "C1";
        obj.enableAccessLevel = false;
      } else if (tagd === "U1" && tags === "F1") {
        obj.title = "User Facility Access";
        obj.tag = "F1";
        obj.enableAccessLevel = false;
      } else if (tagd === "F1" && tags === "U1") {
        obj.title = "Facility User Access";
        obj.tag = "F1";
        if (this.getDetail.select.fauth < 2) {
          obj.enableAccessLevel = true;
        }
      } else {
        obj.title = this.result.basic.title;
        obj.enableAccessLevel = false;
      }
      return obj;
    }
  }
};
</script>
